import {Injectable} from '@angular/core';
import {Location} from '@angular/common';
import {
    HttpErrorResponse,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from "@angular/common/http";
import {StateService} from "@uirouter/core";
import {tap} from 'rxjs/operators';

import {AuthenticationService} from "./authentication.service";
import {AppAlertService} from "./app-alert.service";
import {ParametersService} from "./parameters.service";
import {SubtitlesService} from "./subtitles.service";
import {UpdateService} from "./update.service";

@Injectable({
    providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
    constructor(
        private appAlert: AppAlertService,
        private authentication: AuthenticationService,
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        private location: Location,
        private update: UpdateService,
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        let authReq = req;
        if (this.authentication.token) {
            authReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${this.authentication.token}`)
            });
        }

        return next.handle(authReq).pipe(tap({
            error: (error: HttpErrorResponse) => {
                switch (error.status) {
                    case 401:
                    case 403: { // INFO: skip "User has no permission to module"
                        if (!this.location.path().includes('/login')) {
                            this.authentication.token = '';
                            this.authentication.logout();
                        }
                        break;
                    }
                    case 406: // skip "Not Acceptable"
                    case 409: // skip "Conflict"
                    case 422: // skip "Unprocessable Entity"
                        break;
                    case 470: {
                        const message = `<div class="text-align-center">${this.subtitles.setSubtitle(3529)}</div>`;
                        this.appAlert.showAppAlert(message, this.subtitles.setSubtitle(475), null, false, null);
                        break;
                    }
                    case 520: {
                        // window.location.reload();
                        break;
                    }
                    default: {
                        this.update.stopInterval();
                        this.parameters.offline = true;
                        this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash || 0});
                        this.update.startInterval();
                    }
                }
            }
        }));
    }
}
